import React from 'react';
import { ReactComponent as CloseIcon } from '@src/assets/icons/close.svg';
import { ArcIconButton, ArcStack, ArcText } from '@src/core/ui';
import { PopupWrapperViewProps } from './types';
import { useDispatch } from 'react-redux';
import { setSelectedOrder } from '@src/features/order/pages/orders-page/redux';
import { useTheme, alpha } from '@mui/material';

const PopupWrapperView: React.FC<PopupWrapperViewProps> = (props) => {
  const { title, error, children } = props;
  const theme = useTheme();

  const dispatch = useDispatch();
  const onRemoveOrder = () => dispatch(setSelectedOrder(null));

  return (
    <>
      <ArcStack
        position='fixed'
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={99}
        sx={{
          backgroundColor: alpha(theme.palette.background.default, 0.75),
          cursor: 'pointer'
        }}
        onClick={onRemoveOrder}
      />
      <ArcStack 
        p={2} 
        width='100%' 
        maxWidth={744}
        minWidth={400}
        borderRadius={1}
        position='fixed'
        left='50%'
        top='50%'
        sx={{
          transform: 'translate(-50%, -50%)',
        }}
        zIndex={100}
        bgcolor={error ? 'rose.main' : 'background.paper'}>

        <ArcStack 
          direction='row' 
          alignItems='center' 
          justifyContent='space-between'
          marginTop={0.5}
          marginBottom={2.5}>
          <ArcText.h6 fontWeight={500}> {title} </ArcText.h6>
          <ArcIconButton onClick={onRemoveOrder} sx={{padding:0}}> <CloseIcon /> </ArcIconButton>
        </ArcStack>

        {children}
      </ArcStack>
    </>
  );
};

export default PopupWrapperView;